export default __webpack_public_path__ + "static/media/i_bus-dbl_gn.a50a4f8b.svg";